module.exports = __webpack_public_path__ + "img/motto.e1f84662.png";